import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import "../../../assets/css/components/navbar.css";

function Navbar() {
  const [authData, setAuthData] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const canShowMenu = localStorage.getItem("Pos") === "1";
  const company = localStorage.getItem("company");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/authen`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      if (response.data.status === "OK") {
        setAuthData(response.data.decoded);
      } else {
        window.location.replace("/login");
      }
    } catch (error) {
      window.location.replace("/login");
    }
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const menuConfig = [
    {
      type: "item",
      to: "/",
      icon: "fa-home",
      label: "Dashboard",
      activePaths: ["/"],
    },
    {
      type: "dropdown",
      icon: "fa-folder",
      label: "ไฟล์ข้อมูล",
      menuPaths: [
        "/company",
        "/employee",
        "/debtor",
        "/ARtype",
        "/creditor",
        "/APtype",
        "/tbsetitem",
        "/tb-set-wh",
        "/docType",
      ],
      items: [

        { to: "/company", label: "ข้อมูลบริษัท" },
        { to: "/employee", label: "ข้อมูลพนักงาน" },
        { to: "#", label: "hr" },
        { to: "/debtor", label: "ข้อมูลลูกหนี้" },
        { to: "/ARtype", label: "ข้อมูลประเภทลูกหนี้" },
        { to: "/creditor", label: "ข้อมูลเจ้าหนี้" },
        { to: "/APtype", label: "ข้อมูลประเภทเจ้าหนี้" },
        { to: "/dept", label: "ข้อมูลแผนก" },
        { to: "/position", label: "ข้อมูลตำแหน่ง" },
        { to: "/docType", label: "ข้อมูลประเภทเอกสาร" },
        { to: "/tbsetitem", label: "ข้อมูลสินค้า" },
        { to: "/brand", label: "ข้อมูลแบรนด์สินค้า" },
        { to: "/tb-set-unit", label: "ข้อมูลหน่วยสินค้า" },
        { to: "/tb-set-wh", label: "ข้อมูลคลังสินค้า" },
      ],

    },
    {
      type: "dropdown",
      icon: "fa-shopping-cart",
      label: "ซื้อ",
      menuPaths: ["/purchase-request", "/purchase-order", "/product-receipt"],
      items: [
        { to: "/purchase-request", label: "ใบสั่งซื้อ" },
        { to: "/product-receipt", label: "ใบรับสินค้า(จากPO)" },
        { to: "/product-receipt", label: "รับสินค้ากรณีอื่น" },
        { to: "/invoice", label: "จ่ายสินค้ากรณีอื่น", },

      ],
    },
    {
      type: "dropdown",
      icon: "fa-tags",
      label: "ขาย",
      menuPaths: ["/quotation", "/invoice", "/debit-note", "/credit-note"],
      items: [
        { to: "/quotation", label: "ใบเสนอราคา" },
        { to: "/invoice", label: "ใบกำกับภาษี" },
        { to: "/debit-note", label: "ใบเพิ่มหนี้", disabled: false },
        { to: "/credit-note", label: "ใบลดหนี้", disabled: false },
      ],
    },
    {
      type: "dropdown",
      icon: "fa-user-tie",
      label: "เจ้าหนี้",
      menuPaths: ["/creditor", "/payment-voucher"],
      items: [
        { to: "/creditor", label: "ข้อมูลเจ้าหนี้" },
        { to: "/payment-voucher", label: "ใบสำคัญจ่าย" },
      ],
    },
    {
      type: "dropdown",
      icon: "fa-users",
      label: "ลูกหนี้",
      menuPaths: ["/debtor", "/bill", "/receipt"],
      items: [
        { to: "/debtor", label: "ข้อมูลลูกหนี้" },
        { to: "/bill", label: "ใบวางบิล" },
        { to: "/receipt", label: "ใบเสร็จรับเงิน" },
        { to: "/receipt-voucher", label: "ใบสำคัญรับ" },
      ],
    },
    {
      type: "dropdown",
      icon: "fa-book",
      label: "บัญชี",
      menuPaths: ["/payment-stock", "/tax"],
      items: [
        { to: "/payment-stock", label: "ตรวจสอบค้างจ่าย" },
        { to: "/tax", label: "หนังสือหัก ณ.ที่จ่าย" },
      ],
    },
    {
      type: "dropdown",
      icon: "fa-building",
      label: "คลังสินค้า",
      menuPaths: ["/warehouse-stock", "/treasury-documents"],
      items: [
        { to: "/tbsetitem", label: "ข้อมูลสินค้า" },
        { to: "/warehouse-stock", label: "สต็อกคลังสินค้า" },
        { to: "/treasury-documents", label: "จัดการเอกสารคลัง" },
      ],
    },
    // {
    //   type: "dropdown",
    //   icon: "fa-file",
    //   label: "รายงาน",
    //   activePaths: [
    //     "/reports",
    //     "/sales-report",
    //     "/inventory-movement-report",
    //     "/stock-balance-report",
    //     "/loan-crate-report",
    //     "/deposit-report",
    //     "/overdue-loan-crate-report",
    //     "/receivables-report",
    //     "/payables-report",
    //   ],
    //   items: [
    //     { to: "/reports", label: "รายงานทั้งหมด" },
    //     { to: "/sales-report", label: "รายงานการขาย" },
    //     { to: "/inventory-movement-report", label: "รายงานการเคลื่อนไหวสินค้า" },
    //     { to: "/stock-balance-report", label: "รายงานยอดสต็อกสินค้า" },
    //     { to: "/loan-crate-report", label: "รายงานการยืมสินค้า" },
    //     { to: "/deposit-report", label: "รายงานการฝากสินค้า" },
    //     { to: "/overdue-loan-crate-report", label: "รายงานการยืมสินค้าค้างคืน" },
    //     { to: "/receivables-report", label: "รายงานลูกหนี้" },
    //     { to: "/payables-report", label: "รายงานเจ้าหนี้" },
    //   ],
    // },
    {
      type: "dropdown",
      icon: "fa-users",
      label: "CRM",
      onlyShowWhenPos: true,
      menuPaths: [
        "/sales-report-customer",
        "/purchase-report",
        "/debtor-report",
        "/invoice-report",
        "/top-buying-products",
        "/top-selling-products",
        "/inactive-customers-report",
        "/job-assignment-system",
      ],
      items: [
        { to: "/purchase-report", label: "สรุปรายงานยอดซื้อ" },
        { to: "/sales-report-customer", label: "สรุปรายงานยอดขาย" },
        { to: "/debtor-report", label: "สรุปลูกหนี้ค้างจ่าย" },
        { to: "/invoice-report", label: "สรุปเจ้าหนี้ค้างจ่าย" },
        { to: "/top-buying-products", label: "รายงานสินค้าซื้อเยอะ" },
        { to: "/top-selling-products", label: "รายงานสินค้าขายดี" },
        { to: "/inactive-customers-report", label: "รายงานลูกค้าห่างเหิน" },
        { to: "/job-assignment-system", label: "ระบบมอบหมายงาน" },
      ],
    },
  ];

  const renderMenus = () =>
    menuConfig.map((menu, idx) => {
      if (menu.onlyShowWhenPos && !canShowMenu) return null;

      if (menu.type === "item") {
        return (
          <li className="nav-item" key={idx}>
            <a
              className={`nav-link ${menu.activePaths && menu.activePaths.includes(location.pathname) ? "active" : ""}`}
              href={menu.to}
            >
              <i className={`fas ${menu.icon} me-1`}></i> {menu.label}
            </a>
          </li>
        );
      }

      if (menu.type === "dropdown") {
        return (
          <li className="nav-item dropdown" key={idx}>
            <a
              className={`nav-link dropdown-toggle ${menu.menuPaths && menu.menuPaths.includes(location.pathname) ? "active" : ""}`}
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className={`fas ${menu.icon} me-1`}></i> {menu.label}
            </a>
            <ul className="dropdown-menu">
              {menu.items.map((item, subIdx) => (
                item.label === "hr" ? (
                  <li key={subIdx}><hr className="dropdown-divider " /></li>
                ) : (
                  <li key={subIdx}>
                    <a
                      className={`dropdown-item${item.disabled ? " text-danger disabled" : ""}`}
                      href={item.disabled ? "#" : item.to}
                      style={item.disabled ? {
                        pointerEvents: "none",
                        cursor: "not-allowed",
                        opacity: 0.5
                      } : {}}
                    >
                      {item.label}
                    </a>
                  </li>
                )
              ))}
            </ul>
          </li>
        );
      }

      return null;
    });

  const UserMenu = ({ user }) => (
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle d-flex align-items-center"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <div className="text-end me-2">
          <div className="fw-bold text-white">{user.Emp_Name || ""}</div>
          <small className="text-muted">({user.Comp_ShortName || ""})</small>
        </div>
        <i className="fas fa-user-circle fa-lg"></i>
      </a>
      <ul className="dropdown-menu dropdown-menu-end">
        <li className="dropdown-header">
          <div className="fw-bold">{user.Emp_Name}</div>
          <small className="text-muted">{user.Dept_Name || ""}</small>
          <small className="text-muted d-block">{user.PST_Name || ""}</small>
          <small className="text-muted d-block">
            {user.Comp_Name_TH || ""}
          </small>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <button
            className="dropdown-item text-danger"
            onClick={() => window.location.replace("/login")}
          >
            <i className="fas fa-sign-out-alt me-2"></i> Logout
          </button>
        </li>
      </ul>
    </li>
  );

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img
            src={
              company === "1"
                ? "assets/img/logo_water.jpg"
                : company === "2"
                  ? "assets/img/logo_ice.jpg"
                  : "assets/img/logo.png"
            }
            alt="Logo"
            width="60"
            height="60"
            className="d-inline-block align-text-top"
            style={{
              borderRadius: "30%",
              objectFit: "cover",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
            }}
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">{renderMenus()}</ul>
          <div className="navbar-nav ms-auto">
            <UserMenu user={authData} />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
